import React from 'react';
import MaterialTable from 'material-table'
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import { withSnackbar } from 'notistack';
import Service from '../../config/networkutils';
import UserPermissions from './UserPermission';
import RotateCircleLoading from 'react-loadingg/lib/RotateCircleLoading';
import Auth from '../../utils/authenticate';
import { getDataIsdeletedFalse, getPrimaryColor } from '../Helper/CommonThings';
import LinkIcon from '@material-ui/icons/Link';
import { Autocomplete } from '@material-ui/lab';
import { CoffeeLoading } from 'react-loadingg';
import { Box } from '@material-ui/core';
import { setCookie } from '../../utils/CookieHelper';

const token = Auth.token()


class UserAccess extends React.Component {
    constructor() {
        super()
        this.state = {
            data: [],
            userAddModal: false,
            first_name: '',
            last_name: '',
            email: '',
            isLoading: false,
            linkBUDialog: false,
            buData: [],
            selectedBusinessUnit: [],
            createBusinessUnit: {},
            disableLinkBU: false,
            selectedRow: null,
            userAccess: {}
        }
        this.closeUserAddModal = this.closeUserAddModal.bind(this)
        this.handleChange = this.handleChange.bind(this)
    }

    componentDidMount() {
        this.fetchOps()
        this.getBUData()
        this.getUserAccess()
    }

    getUserAccess() {
        Service.get(`/api/users/get_user_access_data/`, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                let defaultBU = this.props.buData?.default_business_unit
                for (let index = 0; index < res.data.manage_business_units?.length; index++) {
                    const element = res.data?.manage_business_units?.[index];
                    if (element?.business_unit === defaultBU?.id) {
                        console.log(element)
                        this.setState({
                            userAccess: element
                        })
                        break
                    }
                }
            })
            .catch(error => {
                console.log(error)
                if (error.status === 403) {
                    this.props.enqueueSnackbar(error.data.message, {
                        variant: 'warning'
                    });
                } else {
                    this.props.enqueueSnackbar('Something went wrong!', {
                        variant: 'error'
                    });
                }
            });
    }

    getBUData() {
        Service.get(`/api/business/unit/`, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                this.setState({ buData: res.data })
            })
            .catch(error => {
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            });
    }

    fetchOps() {
        this.setState({ isLoading: true })
        Service.get(`/api/users/get_custom_users/`, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                let resData = getDataIsdeletedFalse(res.data)
                this.setState({ data: resData }, () => {

                    this.setState({ isLoading: false })

                })

            })
            .catch(error => {
                if (error.status === 403) {
                    this.props.enqueueSnackbar(error.data.message, {
                        variant: 'warning'
                    });
                } else {
                    this.props.enqueueSnackbar('Something went wrong!', {
                        variant: 'error'
                    });
                }
                this.setState({ isLoading: false })
            });
    }

    putOps(data) {
        data.is_active = data.is_active === 'true' ? true : false
        this.setState({ isLoading: true })
        Service.patch(`/api/users/edit_user_details/`, {
            headers: {
                Authorization: "Token " + token,
            },
            data,
        })
            .then(res => {
                this.fetchOps()
                this.props.enqueueSnackbar('Successfully Updated', {
                    variant: 'success'
                });
            })
            .catch(error => {
                this.setState({ isLoading: false })
                if (error.status === 401) {
                    this.props.enqueueSnackbar(error.data.message, {
                        variant: 'warning'
                    });
                } else if (error.status === 403) {
                    this.props.enqueueSnackbar(error.data.message, {
                        variant: 'warning'
                    });
                } else {
                    this.props.enqueueSnackbar('Something went wrong!', {
                        variant: 'error'
                    });
                }

                this.setState({ isLoading: false })
            });

    }

    closeUserAddModal() {
        this.setState({ userAddModal: false })
    }

    handleChange(e) {
        let { name, value } = e.target
        this.setState({ [name]: value })
    }


    addUser() {

        if (this.state.first_name === '' || this.state.last_name === '' || this.state.email === '') {
            this.props.enqueueSnackbar('All the fields are required.', {
                variant: 'warning',
            });
        }
        else if (!this.state.email.includes("@balfourbeatty.com")) {

            this.props.enqueueSnackbar('Only Balfour Beatty email address is allowed.', {
                variant: 'warning',
            });
        }
        else {

            var json = {
                email: this.state.email.toLowerCase(),
                first_name: this.state.first_name,
                last_name: this.state.last_name,
                email_username: this.state.email.toLowerCase(),
                business_unit: this.state.createBusinessUnit.id,
            }
            // var json2 = {
            //     email: json.email,
            //     email_username: json.email,
            //     first_name: this.state.first_name,
            //     last_name: this.state.last_name,
            //     is_staff: this.state.access === 10 || this.state.access === 20 || this.state.access === 30,
            //     is_lead: this.state.access === 20 || this.state.access === 30,
            //     is_superuser: false,
            //     is_admin: this.state.access === 30,
            //     twof_auth: false,
            //     is_estimator: false,
            //     is_hr: false,
            //     is_active: true,
            //     // role_id: autocompdata !== "" ? autocompdata.id : null,
            // }
            this.setState({ isLoading: true })
            Service.post('/api/users/create_new_user/', {
                headers: {
                    Authorization: "Token " + token,
                },
                data: json,
            })
                .then(res => {
                    // Service.put("/api/request/password/" + json.email + "/?email=" + json.email, {
                    //     headers: {
                    //         Authorization: "Token " + token,
                    //     },
                    //     data: json2,
                    // })
                    //     .then(res1 => {
                    this.setState({ userAddModal: false, isLoading: false });
                    this.props.enqueueSnackbar(json.email + ' is created', {
                        variant: 'success',
                    });
                    this.fetchOps();
                    // })
                    // .catch(error => {
                    //     this.setState({ isLoading: false });
                    //     console.log(error)
                    //     this.props.enqueueSnackbar('Something went wrong!', {
                    //         variant: 'error'
                    //     });
                    // });

                })
                .catch(error => {
                    if (error && error.status === 406) {
                        this.props.enqueueSnackbar(error.data.message, {
                            variant: 'warning'
                        });
                        this.setState({ isLoading: false });
                    } else {
                        this.setState({ isLoading: false });
                        this.props.enqueueSnackbar('Something went wrong!. Try after sometime.', {
                            variant: 'error',
                        });
                    }
                });
        }
    }

    linkBU() {
        if (this.state.selectedBusinessUnit.length === 0) {
            this.props.enqueueSnackbar('Please select atleast one Business Unit', {
                variant: 'warning'
            });
            return
        }
        else {
            this.setState({
                disableLinkBU: true
            })
            Service.post(`/api/user/business/unit/link_and_delink_user_business_unit/`, {
                headers: {
                    Authorization: "Token " + token,
                },
                data: {
                    user: this.state.selectedRow.id,
                    bu_unit: this.state.selectedBusinessUnit.map(bu => bu.id)
                }
            })
                .then(res => {
                    this.fetchOps()
                    this.props.enqueueSnackbar('Successfully Updated', {
                        variant: 'success'
                    });
                    this.setState({
                        disableLinkBU: false,
                        linkBUDialog: false,
                        coffeeLoading: true,
                        selectedBusinessUnit: []
                    }, () => {
                        this.reloadUserInfo()
                    })
                })
                .catch(error => {
                    if (error.status === 403) {
                        this.props.enqueueSnackbar(error.data.message, {
                            variant: 'warning'
                        });

                    } else {
                        this.props.enqueueSnackbar('Something went wrong!', {
                            variant: 'error'
                        });
                    }
                    this.setState({ isLoading: false, disableLinkBU: false })
                });

        }

    }

    reloadUserInfo() {
        Service.get(`/rest-auth/user/`, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res1 => {

                if (!res1.data.twof_auth) {
                    setCookie('ptd_ts_user', JSON.stringify(res1.data), { secure: true, 'max-age': 172800, 'domain': window.location.host, 'samesite': 'strict', 'path': '/', });
                } else {
                    // setOpen(true)
                }
                this.setState({
                    coffeeLoading: false
                })
            })
            .catch(error => {
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error',
                });
            });
    }


    render() {
        return (
            <>
                {this.state.isLoading ? <RotateCircleLoading color={getPrimaryColor()} /> :
                    <div>
                        <MaterialTable
                            title={'Users & Access'}
                            columns={[
                                { title: 'First Name', field: 'first_name' },
                                { title: 'Last Name', field: 'last_name' },
                                { title: 'Email', field: 'email', editable: 'never' },
                                {
                                    title: 'Business Unit', field: 'business_units', editable: 'never',
                                    render: rowData => rowData?.business_units?.map(bu => bu.business_unit_name).join(', '),
                                },
                                {
                                    title: 'Active Status', field: 'is_active', lookup: { false: 'Inactive', true: 'Active' },
                                    editable: this.state.userAccess.activate_user ? 'always' : 'never',
                                },
                            ]}
                            data={this.state.data}
                            options={{
                                paging: false,
                                pageSize: 20,
                                pageSizeOptions: [10, 20, 50, 100],
                                maxBodyHeight: window.screen.height - 250,
                                headerStyle: {
                                    fontWeight: 'bold',
                                },
                                actionsColumnIndex: -1,
                                filtering: true
                            }}
                            editable={{
                                onRowUpdate: this.state.userAccess.create_user
                                    ? (newData, oldData) =>
                                        new Promise((resolve, reject) => {
                                            setTimeout(() => {

                                                this.putOps(newData)
                                                resolve();
                                            }, 1000)
                                        })
                                    : undefined,
                            }}
                            detailPanel={[
                                {
                                    render: rowData => {
                                        return this.state.userAccess.manage_access ? (
                                            <div style={{ padding: '15px' }}>
                                                <UserPermissions value={rowData} edit={true} />
                                            </div>
                                        ) : null;
                                    },
                                }
                            ]}
                            onRowClick={(event, rowData, togglePanel) => togglePanel()}
                            // actions={access.l8a && access.l8a.l8a_b ? [
                            actions={[
                                {
                                    icon: 'add',
                                    tooltip: 'Add User',
                                    isFreeAction: true,
                                    disabled: !this.state.userAccess.create_user,
                                    onClick: (event) => {
                                        this.setState({ userAddModal: true })
                                    }
                                },
                                {
                                    icon: () => <LinkIcon />,
                                    tooltip: 'Link Business Unit',
                                    disabled: !this.state.userAccess.create_user,
                                    onClick: (event, rowData) => {
                                        for (let index = 0; index < this.state.buData.length; index++) {
                                            const element = this.state.buData[index];
                                            if (rowData.business_units && rowData.business_units.find(bu => bu.business_unit === element.id)) {
                                                this.setState(prevState => ({
                                                    selectedBusinessUnit: [...prevState.selectedBusinessUnit, element]
                                                }))
                                            }
                                        }
                                        this.setState({
                                            selectedRow: rowData,
                                            linkBUDialog: true,
                                        })
                                    }
                                }

                                // {
                                //     icon: 'edit',
                                //     tooltip: 'Edit',
                                //     // isFreeAction: true,
                                //     onClick: (event, rowData) => {
                                //         this.setState({ userAddModal: true })
                                //     }
                                // },
                            ]}
                        />

                        <Dialog
                            open={this.state.userAddModal}
                            onClose={this.closeUserAddModal}
                            aria-labelledby="form-dialog-title"
                            maxWidth="xs"
                        >
                            <DialogTitle id="form-dialog-title">Add User</DialogTitle>
                            <DialogContent>
                                <TextField
                                    autoFocus
                                    margin="normal"
                                    id="first_name"
                                    name="first_name"
                                    label="First Name"
                                    type="text"
                                    fullWidth
                                    variant="outlined"
                                    onChange={this.handleChange}
                                />
                                <TextField
                                    autoFocus
                                    margin="normal"
                                    id="last_name"
                                    name="last_name"
                                    label="Last Name"
                                    type="text"
                                    fullWidth
                                    variant="outlined"
                                    onChange={this.handleChange}
                                />
                                <TextField

                                    margin="normal"
                                    id="email"
                                    name="email"
                                    label="Email Address"
                                    type="email"
                                    fullWidth
                                    variant="outlined"
                                    onChange={this.handleChange}
                                />
                                <Box marginTop={2}>
                                    <Autocomplete
                                        id="bu_id"
                                        options={this.state.buData}
                                        disableCloseOnSelect
                                        getOptionLabel={(option) => option.name}
                                        onChange={(e, value) => this.setState({ createBusinessUnit: value })}
                                        size='small'
                                        value={this.state.createBusinessUnit}
                                        renderInput={(params) => (
                                            <TextField {...params} variant="outlined" label="Business Unit" placeholder="Business Unit" />
                                        )}
                                    />
                                </Box>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={this.closeUserAddModal} color="secondary">
                                    Cancel
                                </Button>
                                <Button onClick={this.addUser.bind(this)} color="primary">
                                    Add
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <Dialog
                            open={this.state.linkBUDialog}
                            onClose={() => this.setState({ linkBUDialog: false, selectedBusinessUnit: [] })}
                            aria-labelledby="form-dialog-title"
                            maxWidth="xs"
                            fullWidth
                        >
                            <DialogTitle id="form-dialog-title">Link Business Unit</DialogTitle>
                            <DialogContent>
                                <Autocomplete
                                    multiple
                                    id="role_id"
                                    options={this.state.buData}
                                    disableCloseOnSelect
                                    getOptionLabel={(option) => option.name}
                                    onChange={(e, value) => this.setState({ selectedBusinessUnit: value })}
                                    size='small'
                                    value={this.state.selectedBusinessUnit}
                                    renderInput={(params) => (
                                        <TextField {...params} variant="outlined" label="Business Unit" placeholder="Business Unit" />
                                    )}
                                />
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => this.setState({ linkBUDialog: false, selectedBusinessUnit: [] })} color="secondary">
                                    Cancel
                                </Button>
                                <Button disabled={this.state.disableLinkBU} onClick={() => this.linkBU()} color="primary">
                                    Link
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <Dialog maxWidth="sm" open={this.state.coffeeLoading} aria-labelledby="form-dialog-title">
                            <DialogContent>
                                <Box m={5} p={2}>
                                    <CoffeeLoading />
                                </Box>
                            </DialogContent>
                        </Dialog>
                    </div>
                }
            </>
        )
    }
}

export default withSnackbar(UserAccess);